export default () => {
  const system = useSystemStore();
  const auth = useAuthStore();
  const rbac = useRbac();
  return {
    general: {
      name: 'تنظيمات عمومی',
      icon: 'icon-general',
      color: '#2877DC',
      class: 'general-option',
      show: false,
      items: [{
        icon: 'icon-informationsystem',
        name: 'اطلاعات سامانه',
        value: '/settings/systemInformation',
        permission: auth.user.full_admin,
        items: [
          'لوگو',
          'تعلیق',
          'زبان',
          'الحاق',
          'سامانه',
          'غیر فعال',
          'فایل',
          'پیوست',
          'ضمیمه',
          'عنوان',
          'لینک',
          'معلق',
          'اتچمنت',
          'پسوند',
          'حجم',
          'favicon',
          'attachment',
        ]
      },
      {
        icon: 'icon-privacysettings',
        name: 'تنظیمات امنیتی',
        value: '/settings/securitySettings',
        permission: auth.user.full_admin,
        items: [
          'امنیت',
          'کلمه عبور',
          'پسورد',
          'رمز',
          'رمز عبور',
          'هشدار',
          'پیغام',
          'ورود',
          'لاگین',
          'آلارم',
          'اطلاع رسانی',
          'وب',
          'وب سرویس',
          'ip',
          'password',
          'multi',
          'login',
          'api',
          'webhook',
          'web service',
        ]
      },
      {
        icon: 'icon-usersettings',
        name: 'حساب کاربری',
        value: '/settings/userAccountSettings',
        permission: auth.user.full_admin,
        items: [
          'کاربری',
          'اکانت',
          'تنظیمات پایه',
          'حساب',
          'حساب کاربری',
          'تغییر نام',
          'مجوز',
          'ثبت نام',
          'احراز هویت',
          'یوزر نیم',
          'سازمان',
          'پیش فرض',
          'مشتریان',
          'فعال سازی',
          'الگوی regex',
          'regex',
          'username',
        ]
      },
      {
        icon: 'icon-field',
        name: 'فیلد های سفارشی',
        value: '/settings/customFields',
        permission: auth.user.full_admin && system.license.features.custom_field,
        items: [
          'فیلد',
          'سفارشی',
          'کاستوم',
          'فرم',
          'field',
          'custom',
          'form',
        ]
      },
      {
        icon: 'icon-form',
        name: 'فرم های سفارشی',
        value: '/settings/forms',
        permission: auth.user.full_admin && system.license.features.custom_field,
        items: [
          'فیلد',
          'سفارشی',
          'کاستوم',
          'فرم',
          'field',
          'custom',
          'form',
        ]
      },
      {
        icon: 'icon-pluginsetting',
        name: 'افزونه ها',
        value: '/settings/plugins',
        permission: auth.user.full_admin,
        items: [
          'ویپ',
          'پنل پیامکی',
          'مانیتورینگ',
          'sms',
          'voip',
          'monitoring',
          'extention',
          'plugin'
        ]
      },
      ]
    },
    oraganization: {
      name: 'سازمان',
      icon: 'icon-department',
      color: '#34C38F',
      class: 'organization-option',
      show: false,
      items: [{
        icon: 'icon-product',
        name: 'سرویس‌ها/محصولات',
        value: '/settings/services',
        permission: auth.user.full_admin,
        items: [
          'محصول',
          'خدمت',
          'سرویس',
          'لیست',
          'خدمات',
        ]
      }, {
        icon: 'icon-Shift',
        name: 'شیفت‌های کاری',
        value: '/settings/workingShift',
        permission: auth.user.full_admin && system.license.features.workingshift,
        items: [
          'شیفت',
          'کار',
          'ساعات',
          'زمان',
          'ساعت',
        ]
      }, {
        icon: 'icon-offday',
        name: 'روزهای تعطیل',
        value: '/settings/offDays',
        permission: auth.user.full_admin && system.license.features.workingshift,
        items: [
          'تعطیل',
          'تقویم',
          'روز',
        ]
      },]
    },
    customers: {
      name: 'مشتریان',
      icon: 'icon-userssettings',
      color: '#7367f0',
      class: 'customers-option',
      show: false,
      items: [{
        icon: 'icon-levelcustomers',
        name: 'سطح مشتریان',
        value: '/settings/customerLevel',
        permission: auth.user.full_admin,
        items: [
          'سطح',
          'سطح جدید',
          'ایجاد سطح',
        ]
      },
      {
        icon: 'icon-events',
        name: 'رویدادهای مشتریان',
        value: '/settings/customerEvents',
        permission: auth.user.full_admin && system.license.features.customer_event,
        items: [
          'رویداد',
          'فعالیت',
          'رخداد',
        ]
      },
      {
        icon: 'icon-customdep',
        name: 'فیلد های سفارشی سازمان',
        value: '/settings/organizationCustomFields',
        permission: auth.user.full_admin && system.license.features.organization_custom_field,
        items: [
          'فیلد',
          'سفارشی',
          'اختصاصی'
        ]
      },
      {
        icon: 'icon-customeruser',
        name: 'فیلد های سفارشی مشتریان',
        value: '/settings/customerCustomFields',
        permission: auth.user.full_admin && system.license.features.customer_custom_field,
        items: [
          'فیلد',
          'سفارشی',
          'اختصاصی'
        ]
      },
      ]
    },
    ticket: {
      name: 'تیکت',
      icon: 'icon-ticket1',
      color: '#FF9F43',
      class: 'ticket-option',
      show: false,
      items: [{
        icon: 'icon-genralsettings',
        name: 'تنظیمات عمومی',
        value: '/settings/generalTicketSettings',
        permission: auth.user.full_admin,
        items: [
          'رضایت',
          'نظر',
          'بسته',
          'بستن خودکار',
          'تیکت',
          'بستن',
          'باز کردن',
          'خودکار',
          'اتومات',
        ]
      },
      {
        icon: 'icon-category',
        name: 'دسته‌بندی موضوعی',
        value: '/settings/ticketCategory',
        permission: auth.user.full_admin,
        items: [
          'دسته بندی',
          'گروه بندی',
          'تیکت',
          'طبقه بندی',
          'موضوع',
        ]
      }, {
        icon: 'icon-tag',
        name: 'مدیریت برچسب‌ها',
        value: '/settings/tags',
        permission: rbac.can('manage tags'),
        items: [
          'برچسب',
          'تگ',
        ]
      }, {
        icon: 'icon-cannedresponse',
        name: 'متن های آماده',
        value: '/settings/ticketTemplates',
        permission: auth.user.full_admin && system.license.features.ticket_canned_message,
        items: [
          'متن',
          'قالب',
          'الگو متنی',
          'پیش نویس',
          'متغیر',
          'سریع',
          'آماده',
        ]
      }, {
        icon: 'icon-sla',
        name: 'قوانین SLA',
        value: '/settings/sla',
        permission: (auth.user.full_admin || auth.user.branch_admin) && system.license.features.ticket_sla,
        items: [
          'توافقنامه',
          'قانون',
          'قوانین',
          'خدمات',
          'sla',
        ]
      }, {
        icon: 'icon-assign',
        name: 'اختصاص فرم به تیکت',
        value: '/settings/ticketForms',
        permission: auth.user.full_admin && system.license.features.custom_field,
        items: [
          'فیلد',
          'اختصاص',
          'سفارشی',
          'کاستوم',
          'فرم',
          'field',
          'custom',
          'form',
        ]
      }, {
        icon: 'icon-emailtoticket',
        name: 'تنظیمات ایمیل به تیکت',
        value: '/settings/emailToTicketSettings',
        permission: auth.user.full_admin && system.license.features.email_to_ticket,
        items: [
          'ایمیل',
          'تیکت',
          'تبدیل',
          'email',
          'ticket',
          'convert',
        ]
      },
      ]
    },
    notifications: {
      name: 'اطلاع رسانی',
      icon: 'icon-notifications',
      color: '#DA4167',
      class: 'notice-option',
      show: false,
      items: [{
        icon: 'icon-genralsettingsnotif',
        name: 'تنظیمات عمومی',
        value: '/settings/generalNoticeSettings',
        permission: auth.user.full_admin,
        items: [
          'اطلاعیه',
          'ایمیل',
          'پیامک',
          'کلید',
          'webhook',
          'hook',
          'sms',
          'key',
        ]
      },
      {
        icon: 'icon-notification',
        name: 'شیوه‌های اطلاع‌رسانی',
        value: '/settings/notice',
        permission: auth.user.full_admin,
        items: [
          'ایمیل',
          'پیامک',
          'پروتکل',
          'اطلاع',
          'اطلاع رسانی',
          'پوش',
          'نوتیف',
          'نوتیفیکیشن',
          'تلگرام',
          'smtp',
          'webhook',
          'web',
          'hook',
          'sms',
          'email',
        ]
      },
      ]
    },
    knowledgebase: {
      name: 'پایگاه دانش',
      icon: 'icon-paygahdaneshseting',
      color: '#0b5497',
      class: 'knowledgebase-option',
      show: false,
      items: [{
        icon: 'icon-website',
        name: 'تنظیمات عمومی',
        value: '/settings/knowledgeBaseSettings',
        permission: system.license.features.kb_core && auth.user.full_admin,
        items: [
          'ایمیل',
          'پیامک',
          'پروتکل',
          'اطلاع',
          'اطلاع رسانی',
          'پوش',
          'نوتیف',
          'نوتیفیکیشن',
          'تلگرام',
          'smtp',
          'webhook',
          'web',
          'hook',
          'sms',
          'email',
        ]
      },
      {
        icon: 'icon-frame',
        name: 'قالب‌های آماده',
        value: '/settings/knowledgebaseTemplate',
        permission: system.license.features.kb_core && auth.user.full_admin,
        items: [
          'اطلاعیه',
          'ایمیل',
          'پیامک',
          'کلید',
          'webhook',
          'hook',
          'sms',
          'key',
        ]
      },
      ]
    },
  };
}
